export default __webpack_public_path__ + "static/media/La_maison_de_l_artiste_grand_porte_cle.e7305688.png";